exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal{overflow-y:auto!important}@media (max-width:600px){.modal .modal-dialog{height:auto!important}}", ""]);

// exports
